"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAds = getAds;
async function getAds(advertisingRepo, page = 1, pageSize = 10) {
    return advertisingRepo.getAds(page, pageSize);
}
